const awardsList = [
  {
    label: "San Francisco – Oakland Bay Bridge, United States",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=1",
    link: "#",
  },
  {
    label: "Bird",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=2",
    link: "#",
  },
  {
    label: "Bali, Indonesia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=3",
    link: "#",
  },
  {
    label: "NeONBRAND Digital Marketing, Las Vegas, United States",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=4",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=5",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=6",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=7",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=8",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=9",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=10",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=11",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=12",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=13",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=14",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=15",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=16",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=17",
    link: "#",
  },
  {
    label: "Goč, Serbia",
    imgPath: "https://via.placeholder.com/300x100/D1DBE3?text=18",
    link: "#",
  },
];

export default awardsList;
